module.exports = __webpack_public_path__ + "static/media/stack-exchange.26af9bc1.svg";